import { datetime, type Moment } from '@common/services/datetime';

export function toMinutes(time: Moment | undefined): number | undefined {
  return time ? time.hours() * 60 + time.minutes() : undefined;
}

// NOTE: antd's picker hands back a Moment, and utc(true) keeps that wall clock instead of
// converting it, which is what the mutation expects.
export function utcDate(date: Moment | string | undefined) {
  return date ? datetime(date as string).utc(true) : undefined;
}

const TIME_INCREMENT_MINUTES = 15;

export async function validateTimeIncrements(fieldName: string, value: Moment) {
  if (value && value.minutes() % TIME_INCREMENT_MINUTES !== 0) {
    return Promise.reject(
      `${fieldName} must be in ${TIME_INCREMENT_MINUTES} minute increments.`
    );
  }

  return Promise.resolve();
}

const DEFAULT_LOWER_BOUND_MINUTES = 0;
const DEFAULT_UPPER_BOUND_MINUTES = 120;

export async function validateLunchBreakLength(
  currentTime: Moment | undefined,
  lowerBoundCandidates: (Moment | undefined)[],
  upperBoundCandidates: (Moment | undefined)[],
  options: {
    lowerExclusive: boolean;
    upperExclusive: boolean;
    errorMessage: string;
  }
) {
  if (!currentTime) return;

  const current = toMinutes(currentTime)!;

  const lowerMinutes = lowerBoundCandidates
    .map(toMinutes)
    .filter((m): m is number => m !== undefined);
  const upperMinutes = upperBoundCandidates
    .map(toMinutes)
    .filter((m): m is number => m !== undefined);

  const lowerBound =
    lowerMinutes.length > 0
      ? Math.max(...lowerMinutes)
      : DEFAULT_LOWER_BOUND_MINUTES;
  const upperBound =
    upperMinutes.length > 0
      ? Math.min(...upperMinutes)
      : DEFAULT_UPPER_BOUND_MINUTES;

  const lowerViolation = options.lowerExclusive
    ? current <= lowerBound
    : current < lowerBound;
  const upperViolation = options.upperExclusive
    ? current >= upperBound
    : current > upperBound;

  if (lowerViolation || upperViolation) {
    return Promise.reject(options.errorMessage);
  }

  return Promise.resolve();
}
